/**
 * File: DropDown.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.1.4
 * Created: 2025-11-09
 * Last Updated: 2026-02-12
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { useState } from "react";

// Local project files
import { LinkButton } from "../ui/Buttons";
import FeatureCard from "../ui/FeatureCard";

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function DropDown({ props }) {
    const {
        label,
        featureText,
        features,
        actionImage,
        actionHeader,
        actionDescription,
        actionButtonText,
        actionButtonLink,
    } = props;

    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = () => {
        setIsOpen(true);
    };
    
    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <>
            <div
                className={`dropdown ${isOpen ? "dropdown--active" : ""}`}
                onMouseEnter={handleOpen}
                onMouseLeave={handleClose}
            >
                <p className="dropdown__label">{label}</p>
                <div className="dropdown__content">
                    <div className="dropdown__container">
                        <div className="dropdown__features">
                            <p>{featureText}</p>
                            {features.map((feature) => (
                                <FeatureCard
                                    key={feature.id}
                                    link={feature.link}
                                    image={feature.image}
                                    header={feature.header}
                                    description={feature.description}
                                    onClick={handleClose}
                                />
                            ))}
                        </div>
                        <hr></hr>
                        <div className="dropdown__hero">
                            <img
                                src={actionImage}
                                className="dropdown__image"
                            ></img>
                            <div className="dropdown__hero-headers">
                                <h4>{actionHeader}</h4>
                                <p>{actionDescription}</p>
                                <hr></hr>
                                <LinkButton
                                    text={actionButtonText}
                                    link={actionButtonLink}
                                    onClick={handleClose}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DropDown;
